import request from '@/utils/request'

const payApi = process.env.VUE_APP_PAY_API

// 根据产品分类编号查询产品权益
export function queryValueAddedServiceCategoryRightsApi(categoryCode) {
  return request(
    {
      url: payApi + `/avs/product-category/${categoryCode}/rights`,
      method: 'get'
    },
    { needLoading: false }
  )
}

// 根据产品编号查询sku(产品套餐)
export function querySkuByValueAddedServiceApi(productCode) {
  return request({
    url: payApi + `/avs/products/${productCode}/skus`,
    method: 'get'
  })
}

// 增值服务下单
export function buyValueAddedServiceApi(data) {
  return request({
    url: payApi + '/avs/order/pay',
    method: 'post',
    data
  })
}

// 查询增值服务支付状态
export function queryValueAddedServicePayStatusApi({ payCode }) {
  return request({
    url: payApi + `/avs/order/${payCode}/pay/status`,
    method: 'get'
  })
}

// 根据产品编号查询账户余额(仅针对次数扣费类产品， 如标书预览次数、数字CA抵扣券)
export function queryValueAddedServiceAccountBalanceApi(productCode) {
  return request({
    url: payApi + `/avs/product/${productCode}/account/remain`,
    method: 'get'
  })
}

// 根据产品编号查询产品权益
export function queryValueAddedServiceProductRightsApi(productCode) {
  return request({
    url: payApi + `/avs/products/${productCode}/rights`,
    method: 'get'
  })
}

// 用户提交个人信息
export function buyIntentsApi(data) {
  return request({
    url: payApi + `/avs/buy-intents`,
    method: 'post',
    data
  })
}
